import { jsx as f } from "@emotion/react/jsx-runtime";
import { useState as m, useRef as l, useEffect as n } from "react";
import { StyledExpandable as a } from "./Expandable.styled.js";
import { ANIMATION_DURATION as x } from "./Expandable.types.js";
const p = ({
  children: s,
  opened: t,
  minHeight: i = 0,
  className: o
}) => {
  const [u, c] = m(null), e = l(void 0), r = l(null);
  return n(() => {
    t ? r.current && c(r.current.scrollHeight ?? 0) : c(0);
  }, [r.current?.scrollHeight, t]), n(() => {
    if (r.current)
      return t ? (r.current.style.maxHeight = `${u}px`, e.current = setTimeout(() => {
        r.current && (r.current.style.maxHeight = "initial", r.current.style.overflow = "visible");
      }, x)) : (clearTimeout(e.current), r.current.style.maxHeight = `${u}px`, e.current = setTimeout(() => {
        r.current && (r.current.style.maxHeight = `${i}px`, r.current.style.overflow = "hidden");
      }, 0)), () => {
        clearTimeout(e.current);
      };
  }, [u, i, t]), /* @__PURE__ */ f(a, { ref: r, className: o, opened: t, minHeight: i, children: s });
};
export {
  p as Expandable
};
